import { Component, ElementRef, inject, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { PageService } from "@gea-waldviertler-website/shop-lib";
import { StructuredDataMerchantReturnPolicyInterface } from "./models";
import { CountryInterface, KeyValueInterface } from "@gea-waldviertler-website/gea-models";

@Component({
  selector: 'gea-shop-structured-data-organization',
  templateUrl: './structured-data.component.html',
  styleUrls: [],
  standalone: false
})
export abstract class StructuredDataAbstractComponent implements OnInit, OnChanges {
  @ViewChild('jsonLdScript', {read: ElementRef, static: false}) public jsonLdScript?: ElementRef<HTMLDivElement>

  protected renderTried: number = 0
  protected renderer2: Renderer2
  protected countries: CountryInterface[] = []
  protected pageService: PageService

  constructor(
  ) {
    this.renderer2 = inject(Renderer2)
    this.pageService = inject(PageService)
  }

  ngOnInit(): void {
    this.pageService.getConfigSubject().subscribe(config => {
      if (config) {
        this.countries = config.countries
        this.generate()
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generate()
  }

  protected abstract generateJsonLd(): [] | KeyValueInterface | undefined

  generate(): void {
    if (! this.jsonLdScript) {
      this.renderTried++
      if (this.renderTried < 100) {
        setTimeout(() => {
          this.generate()
        }, 100)
      }
      return
    }

    let data = this.generateJsonLd()

    // do not render if data is undefined
    if (! data) return

    // if not an array, put into to allow iterating
    if (! Array.isArray(data)) {
      data = [ data ]
    }

    // remove any structured data
    if (this.jsonLdScript.nativeElement.children) {
      for (let child of Array.from(this.jsonLdScript.nativeElement.children)) {
        this.jsonLdScript.nativeElement.removeChild(child)
      }
    }

    // iterate items of given structured data
    for (const item of data as []) {
      let script = this.renderer2.createElement('script') as HTMLScriptElement
      script.type = `application/ld+json`
      script.text = JSON.stringify(item)
      this.renderer2.appendChild(this.jsonLdScript.nativeElement, script)
    }
  }

  protected generateMerchantReturnPolicyJsonLd(generic = false): StructuredDataMerchantReturnPolicyInterface {
    let data: StructuredDataMerchantReturnPolicyInterface = {
      "@context": "https://schema.org",
      "@type": "MerchantReturnPolicy",
      name: "GEA - Allgemeine Rückgabebedingungen",
      returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
      merchantReturnDays: 14,
      returnMethod: "https://schema.org/ReturnByMail",
      returnFees: "https://schema.org/ReturnFeesCustomerResponsibility",
      applicableCountry: this.countries.map((item) => {
        return item.code
      }),
      refundType: "FullRefund",
      returnPolicyCountry: "AT"
    }

    // Generic means for the whole site, referenced by products.
    // If not generic, this should be an item for a product or variant
    if (generic) {
      data["@id"] = "#return_policy"
    }

    return data
  }
}
